import { render, staticRenderFns } from "./LmsWebSocket.vue?vue&type=template&id=eda410cc&scoped=true"
import script from "./LmsWebSocket.vue?vue&type=script&lang=js"
export * from "./LmsWebSocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda410cc",
  null
  
)

export default component.exports